var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MainContent,{attrs:{"title":"Detalles del usuario"}},[_c(_setup.UsuarioShow,{attrs:{"lista-id":_vm.lista_id,"user-id":_vm.user_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }